import React, { Component } from 'react';

import { RouteComponentProps } from '@reach/router';
import { Elements, StripeProvider } from 'react-stripe-elements';

import { IStripeToken } from '../../store/user/store';

import { stripeFont, stripeKeys } from '../../config';
import InjectedForm from './CheckoutForm';

const appEnv: 'dev' | 'prod' | undefined = process.env.REACT_APP_STAGE as any;

const stripeKey: string | undefined = appEnv ? stripeKeys[appEnv] : undefined;

interface IProps extends RouteComponentProps {
  onComplete?: (completed: boolean) => void;
  onError?: (el: string, msg: string | undefined) => void;
  onSubmit: (token: IStripeToken) => void;
}

interface IState {
  [x: string]: boolean;
  cardCvcCompleted: boolean;
  cardExpiryCompleted: boolean;
  cardNameCompleted: boolean;
  cardNumberCompleted: boolean;
  completed: boolean;
  postalCodeCompleted: boolean;
}

const fonts = [{ cssSrc: stripeFont.src }];

class CreditCard extends Component<IProps, IState> {
  public form: React.RefObject<any>;

  constructor(props: IProps) {
    super(props);

    this.state = {
      cardCvcCompleted: false,
      cardExpiryCompleted: false,
      cardNameCompleted: false,
      cardNumberCompleted: false,
      completed: false,
      postalCodeCompleted: false
    };

    this.form = React.createRef();

    if (!!!stripeKey) {
      // let whoever is in charge know they forgot the stripe key on .env file
      // tslint:disable-next-line: no-console
      console.warn('Stripe key is not set on .env file');
    }
  }

  public onCardUpdate = (event: stripe.elements.ElementChangeResponse): void => {
    if (event.error && this.props.onError) {
      this.props.onError(event.elementType, event.error.message);
    }

    const wasCompleted = this.state.completed;

    this.setState(
      {
        [`${event.elementType}Completed`]: event.complete
      },
      () => {
        const completed =
          this.state.cardCvcCompleted &&
          this.state.cardExpiryCompleted &&
          this.state.cardNameCompleted &&
          this.state.cardNumberCompleted &&
          this.state.postalCodeCompleted;

        if (wasCompleted !== completed && this.props.onComplete) {
          this.props.onComplete(completed);
        }

        this.setState({ completed });
      }
    );
  };

  public submit = (): void => {
    this.form.current.getWrappedInstance().submit();
  };

  public onSubmit = (token: IStripeToken): void => {
    this.props.onSubmit(token);
  };

  public render(): JSX.Element {
    return stripeKey ? (
      <StripeProvider apiKey={stripeKey}>
        <Elements fonts={fonts}>
          <InjectedForm onSubmit={this.onSubmit} onCardUpdate={this.onCardUpdate} ref={this.form} />
        </Elements>
      </StripeProvider>
    ) : (
      <></>
    );
  }
}

export { CreditCard };
